import React, { useMemo, useState } from 'react';
import {
    Button, Typography, Dialog, DialogTitle, DialogContent, Tooltip, Grid, IconButton
} from '@material-ui/core';
import {
    Security, Edit, Delete
} from '@material-ui/icons';
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from '@material-ui/core/styles';
import { useUsers, useDeleteUser } from '~/user';
import Swal from '#/swal';
import Form from './Form';

import { actions } from '../auth/sagaSlice';
import { connect } from 'react-redux';

const useStyles = makeStyles(theme => ({
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
        }
    },
    redButton: {
        color: '#fff',
        backgroundColor: '#DB2828'
    }
}));


const UserList = connect(state => ({
    isSignedIn: state.auth.isSignedIn,
    isFetching: state.auth.isFetching
}), actions)(props => {


    const { data: users, isLoading } = useUsers();
    const { mutate: deleteUser } = useDeleteUser();
    const [initialValues, setInitialValues] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const classes = useStyles();


    const handleDelete = async id => {

        const { value } = await Swal.fire.warning();
        if (value) {

            deleteUser(id);
        }
    };

    const columns = useMemo(() => [
        {
            renderHeader: () => <strong>Name</strong>,
            field: 'name',
            flex: 0.5
        },
        {
            renderHeader: () => <strong>Email</strong>,
            field: 'email',
            flex: 1
        },
        {
            renderHeader: () => <strong>Role</strong>,
            field: 'scope',
            flex: .5
        },
        {
            renderHeader: () => <strong>Departments</strong>,
            field: 'departments',
            valueGetter: ({ value }) => value.map(dept => dept.name).join(', '),
            renderCell: ({ row }) => {

                const value = (row.departments || []).map(dept => dept.name).join(', ');

                return (
                    <Tooltip title={value}>
                        <div>
                            {value}
                        </div>
                    </Tooltip>
                );
            },
            flex: 1
        },
        {
            renderHeader: () => <strong>Properties</strong>,
            valueGetter: ({ value }) => value.map(prop => prop.name).join(', '),
            renderCell: ({ row }) => {

                const value = (row.properties || []).map(prop => prop.name).join(', ');

                return (
                    <Tooltip title={value}>
                        <div>
                            {value}
                        </div>
                    </Tooltip>
                );
            },
            field: 'properties',
            flex: 1
        },
        {
            field: 'actions',
            flex: 1,
            renderHeader: () => <strong>Actions</strong>,
            renderCell: ({ row }) => (

                <div>
                    <Tooltip title='Manage Access'>
                        <IconButton onClick={() => props.history.push(`/users/${row.id}/access`)}>
                            <Security />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title='Edit'>
                        <IconButton onClick={() => {
                            setInitialValues(row);
                            setModalOpen(true);
                        }}>
                            <Edit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title='Delete'>
                        <IconButton onClick={ () => handleDelete(row.id) }>
                            <Delete />
                        </IconButton>
                    </Tooltip>
                </div>

            ),
            // hide: !isAdmin,
            align: 'right',
            headerAlign: 'right'

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ], []);


    return (
        <div>
            <Grid container justifyContent='space-between' spacing={3} style={{ marginBottom: '10px' }}>
                <Grid item>
                    <Typography gutterBottom variant='h4' display='inline'>
                    Users
                    </Typography>
                </Grid>
                <Grid item>

                    <Button
                        children='New User'
                        variant='contained'
                        color='primary'
                        onClick={() => {
                            setInitialValues(null);
                            setModalOpen(true);
                        }}
                    />
                </Grid>

            </Grid>

            <div style={{ width: '100%' }}>
                <DataGrid
                    className={classes.dataGrid}
                    loading={isLoading}
                    columns={columns}
                    rows={users || []}
                    autoHeight
                    disableSelectionOnClick
                    disableColumnSelector
                    disableDensitySelector
                    hideFooterSelectedRowCount

                />
            </div>


            <Dialog fullWidth open={modalOpen} onClose={() => setModalOpen(false)}>
                <DialogTitle>
                    {initialValues ? 'Edit' : 'New'} User
                </DialogTitle>
                <DialogContent>
                    <Form closeModal={() => setModalOpen(false)} initialValues={initialValues} />
                </DialogContent>
            </Dialog>
        </div>
    );
});


export default UserList;

